import React from 'react'
import Box from '@material-ui/core/Box'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/styles/makeStyles'
import { Product } from '../model'
import SwipeableViews from 'react-swipeable-views'
import { ProductNameView } from './name'

const useStyles = makeStyles((theme: any) => ({
    root: {
        '& .ProductDescriptionTabsItem': {
            height: '512px',
            width: '48px',
            '& .MuiTabs-root': {
                transform: 'rotate(270deg) translate(-232px, -232px)',
                width: '512px',
                '& .MuiTabs-indicator': {
                    display: 'none'
                },
                '& .MuiTabs-flexContainer': {
                    flexDirection: 'row-reverse'
                },
                '& .Tab': {
                    backgroundColor: theme.palette.secondary.main,
                    color: theme.palette.secondary.contrastText,
                    textTransform: 'none',
                    fontWeight: 'normal',
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText
                    }
                },
                '& .Tab:nth-child(2)': {
                    margin: theme.spacing(0, 2)
                },
            }
        },
        '& .ProductDescriptionContentItem': {
            flexGrow: 1,
            padding: theme.spacing(0, 0, 0, 1),
            maxWidth: '92%',
            '& .ProductDescriptionTemplates-root': {
                '& .ProductDescriptionTemplates-fileItem': {
                    listStyleType: 'none',
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                '& .ProductDescriptionTemplates-filesContainer': {
                    paddingLeft: 0
                }
            }
        },
        '& .ExpansionPanel': {
            border: '1px solid rgba(0, 0, 0, .125)',
            boxShadow: 'none',
            margin: 'auto',
            '&:not(:last-child)': {
                borderBottom: 0
            },
            '&:before': {
                display: 'none'
            }
        },
        '& .ExpansionPanelSummary': {
            backgroundColor: theme.palette.secondary.main,
            borderBottom: '1px solid rgba(0, 0, 0, .125)',
            marginBottom: -1,
            minHeight: 56,
            '&$expanded': {
                minHeight: 56
            }
        },
        '& .ExpansionPanelDetails': {
            padding: theme.spacing(1)
        }
    }
}), { name: 'ProductDescription' })

export interface ProductDescriptionProps {
    product: Product
    pictureVisible?: boolean
}

export const ProductDescriptionView = (props: ProductDescriptionProps) => {
    const [sectionTab, setSectionTab] = React.useState(0)
    const classes = useStyles(props)

    return <Box className={classes.root}>
        <ProductNameView product={props.product} pictureVisible={props.pictureVisible} />
        <Hidden smDown>
            <Grid container className='ProductDescriptionItem' wrap='nowrap'>
                <Grid item className='ProductDescriptionTabsItem'>
                    <Tabs
                        orientation='horizontal'
                        variant='standard'
                        indicatorColor='secondary'
                        value={sectionTab}
                        onChange={(_, newTab) => setSectionTab(newTab)}
                    >
                        {props.product.description.map((section, index) =>
                            <Tab
                                key={index}
                                label={section.label}
                                className='Tab' />)}
                    </Tabs>
                </Grid>
                <Grid item className='ProductDescriptionContentItem'>
                    <SwipeableViews index={sectionTab} axis='x'>
                        {props.product.description.map((section, index) => 
                            section.contentElement 
                                ? <section.contentElement key={index}/>
                                : <div key={index} dangerouslySetInnerHTML={{ __html: section.content }}></div>
                        )}
                    </SwipeableViews>
                </Grid>
            </Grid>
        </Hidden>
        <Hidden mdUp>
            {props.product.description.map((section, index) =>
                <ExpansionPanel key={index} square expanded={sectionTab === index} onChange={() => setSectionTab(index === sectionTab ? -1 : index)} className='ExpansionPanel'>
                    <ExpansionPanelSummary aria-controls={`panel${index}d-content`} id={`panel${index}d-header`} className='ExpansionPanelSummary'>
                        <Typography>{section.label}</Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails className='ExpansionPanelDetails'>
                        {section.contentElement 
                            ? <Box><section.contentElement/></Box>
                            : <Box dangerouslySetInnerHTML={{ __html: section.content }}></Box>
                        }
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            )}
        </Hidden>
    </Box>
}